import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import DashLayout from '@/layouts/Dash'
import store from '@/store'

import cookies from 'vue-cookies'

const router = createRouter({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: DashLayout,
      meta: {
        authRequired: true,
      },
      children: [
        {
          path: '/',
          name: 'Dashboard',
          meta: { title: 'Dashboard' },
          component: () => import('./views/dashboard'),
        },
        // {
        //   path: '/dashboard-trial',
        //   name: 'Dashboard Trial',
        //   meta: { title: 'Dashboard Trial' },
        //   component: () => import('./views/dashboard'),
        // },
        {
          path: '/about/who-we-are',
          name: 'Who We Are',
          meta: { title: 'Who We Are' },
          component: () => import('./views/about/WhoWeAre'),
        },
        {
          path: '/about/chapters',
          name: 'Chapters',
          meta: { title: 'Chapters' },
          component: () => import('./views/about/Chapters'),
        },
        {
          path: '/about/working-group',
          name: 'Working Group',
          meta: { title: 'Working Group' },
          component: () => import('./views/about/WorkingGroup'),
        },
        {
          path: '/about/inaheart-member',
          name: 'Inaheart Member',
          meta: { title: 'Inaheart Member' },
          component: () => import('./views/about/InaheartMember'),
        },
        {
          path: '/about/contact-us',
          name: 'Contact Us',
          meta: { title: 'Contact Us' },
          component: () => import('./views/about/ContactUs'),
        },
        {
          path: '/guidelines/statements',
          name: 'Guidelines & Statements',
          meta: { title: 'Guidelines & Statements' },
          component: () => import('./views/guidelines/GuidelinesStatements'),
        },
        {
          path: '/guidelines/journal',
          name: 'Indonesian Journal of Cardiology',
          meta: { title: 'Indonesian Journal of Cardiology' },
          component: () => import('./views/guidelines/IndonesianJournal'),
        },
        {
          path: '/guidelines/news',
          name: 'News & Articles',
          meta: { title: 'News & Articles' },
          component: () => import('./views/guidelines/NewsArticles'),
        },
        {
          path: '/guidelines/events',
          name: 'Events',
          meta: { title: 'Events' },
          component: () => import('./views/guidelines/Events'),
        },
        {
          path: '/content/:id',
          name: 'ContentDetail',
          meta: { title: 'Content Detail' },
          component: () => import('./views/guidelines/ContentDetail.vue'),
        },
        {
          path: '/courses/acls',
          name: 'ACLS Training',
          meta: { title: 'ACLS Training' },
          component: () => import('./views/courses/ACLSTraining'),
        },
        {
          path: '/courses/programs',
          name: 'Courses & Programs (Coming Soon)',
          meta: { title: 'Courses & Programs (Coming Soon)' },
          component: () => import('./views/courses/CoursesPrograms'),
        },
        {
          path: '/admin/users',
          name: 'User Management',
          meta: {
            title: 'User Management',
            requiresAdmin: true,
          },
          component: () => import('./views/admin/UserManagement'),
        },
        {
          path: '/admin/groups',
          name: 'Group Management',
          meta: {
            title: 'Group Management',
            requiresSuperAdmin: true,
          },
          component: () => import('./views/admin/GroupManagement'),
        },
        {
          path: '/akun/edit-profile',
          name: 'Edit Profile',
          meta: {
            title: 'Edit Profile',
          },
          component: () => import('./views/akun/EditProfile.vue'),
        },
        {
          path: '/akun/reset-password',
          name: 'Reset Password',
          meta: {
            title: 'Reset Password',
          },
          component: () => import('./views/akun/ResetPassword'),
        },
        {
          path: '/surat-masuk',
          name: 'Surat Masuk',
          meta: { title: 'Surat Masuk' },
          component: () => import('./views/surat/SuratMasuk'),
        },
        {
          path: '/surat-masuk/registrasi',
          name: 'Registrasi Surat Masuk',
          meta: { title: 'Registrasi Surat Masuk' },
          component: () => import('./views/surat/RegistrasiSuratMasuk'),
        },
        {
          path: '/surat-masuk/update/:id',
          name: 'Update Surat Masuk',
          meta: { title: 'Update Surat Masuk' },
          component: () => import('./views/surat/UpdateSuratMasuk'),
        },

        {
          path: '/surat-keluar',
          name: 'Surat Keluar',
          meta: { title: 'Surat Keluar' },
          component: () => import('./views/surat-keluar/list-surat-keluar'),
        },
        {
          path: '/surat-keluar/create',
          name: 'Surat Keluar Create',
          meta: { title: 'Buat Surat Keluar' },
          component: () => import('./views/surat-keluar/create'),
        },
        {
          path: '/surat-keluar/:id/view',
          name: 'Surat Keluar View',
          meta: { title: 'Detail Surat Keluar' },
          component: () => import('./views/surat-keluar/view'),
        },
        {
          path: '/surat-keluar/:id/detail-hc',
          name: 'Surat Keluar Detail Hard Copy',
          meta: { title: 'Detail Surat Keluar' },
          component: () => import('./views/surat-keluar/detail-hard-copy'),
        },
        {
          path: '/surat-keluar/:id',
          name: 'Surat Keluar Detail',
          meta: { title: 'Detail Surat Keluar' },
          component: () => import('./views/surat-keluar/update'),
        },
        {
          path: '/disposisi-masuk',
          name: 'Disposisi Masuk',
          meta: { title: 'Disposisi Masuk' },
          component: () => import('./views/disposisi/DisposisiMasuk'),
        },
        {
          path: '/disposisi-masuk/:id',
          name: 'Detail Disposisi Masuk',
          meta: { title: 'Detail Disposisi Masuk' },
          component: () => import('./views/disposisi/DetailDisposisiMasuk'),
        },

        {
          path: '/ttd-digital',
          name: 'TTD Digital Surat',
          meta: { title: 'TTD Digital Surat' },
          component: () => import('./views/ttd-digital/list'),
        },
        {
          path: '/ttd-digital/:id',
          name: 'TTD Digital Detail',
          meta: { title: 'Detail TTD Digital' },
          component: () => import('./views/ttd-digital/detail'),
        },
        {
          path: '/pengaturan-surat',
          name: 'Pengaturan Surat',
          meta: { title: 'Pengaturan Surat' },
          component: () => import('./views/pengaturan-surat/pengaturan-surat'),
        },
        {
          path: '/laporan-dinas',
          name: 'Laporan Dinas',
          meta: { title: 'Laporan Dinas' },
          component: () => import('./views/report-dinas'),
        },
        {
          path: '/laporan-dinas/detail/:id',
          name: 'Detail Laporan Dinas',
          meta: { title: 'Detail Laporan Dinas' },
          component: () => import('./views/report-dinas/detail.vue'),
        },
        {
          path: '/cash-out',
          name: 'Pencairan Uang Dinas',
          meta: { title: 'Pencairan Uang Dinas' },
          component: () => import('./views/report-dinas/cash-out'),
        },
        {
          path: '/cash-out/detail/:id',
          name: 'Detail Pencairan Uang Dinas',
          meta: { title: 'Detail Pencairan Uang Dinas' },
          component: () => import('./views/report-dinas/cash-out/detail.vue'),
        },
        {
          path: '/verifikasi',
          name: 'Verifikasi Surat',
          meta: { title: 'Verifikasi Surat' },
          component: () => import('./views/verifikasi'),
        },
        {
          path: '/verifikasi/:id',
          name: 'Detail Verifikasi Surat',
          meta: { title: 'Detail Verifikasi Surat' },
          component: () => import('./views/verifikasi/detail.vue'),
        },
        {
          path: '/event',
          name: 'Kalender Event',
          meta: { title: 'Kalender Event' },
          component: () => import('./views/event'),
        },
        {
          path: '/event/tambah',
          name: 'Kalender Event Tambah',
          meta: { title: 'Kalender Event Tambah' },
          component: () => import('./views/event/add.vue'),
        },
        {
          path: '/event/edit/:id',
          name: 'Kalender Event Edit',
          meta: { title: 'Kalender Event Edit' },
          component: () => import('./views/event/edit.vue'),
        },
        {
          path: '/event/detail/:id',
          name: 'Kalender Event Detail',
          meta: { title: 'Kalender Event Detail' },
          component: () => import('./views/event/detail.vue'),
        },
        {
          path: '/event/kirim-notif/:id',
          name: 'Kalender Event Kirim Notif',
          meta: { title: 'Kalender Event Kirim Notif' },
          component: () => import('./views/event/sendNotif.vue'),
        },
        {
          path: '/notulensi',
          name: 'Notulensi',
          meta: { title: 'Notulensi' },
          component: () => import('./views/notulensi'),
        },
        {
          path: '/notulensi/tambah',
          name: 'Tambah Notulensi',
          meta: { title: 'Tambah Notulensi' },
          component: () => import('./views/notulensi/form.vue'),
        },
        {
          path: '/notulensi/edit/:id',
          name: 'Edit Notulensi',
          meta: { title: 'Edit Notulensi' },
          component: () => import('./views/notulensi/form.vue'),
        },
        {
          path: '/user-management',
          name: 'Manajemen User',
          meta: { title: 'Manajemen User' },
          component: () => import('./views/Home'),
        },
        {
          path: '/about/who-we-are',
          name: 'Who We Are',
          meta: { title: 'Who We Are' },
          component: () => import('./views/about/WhoWeAre'),
        },
        {
          path: '/about/chapters',
          name: 'Chapters',
          meta: { title: 'Chapters' },
          component: () => import('./views/about/Chapters'),
        },
        {
          path: '/about/working-group',
          name: 'Working Group',
          meta: { title: 'Working Group' },
          component: () => import('./views/about/WorkingGroup'),
        },
        {
          path: '/about/inaheart-member',
          name: 'Inaheart Member',
          meta: { title: 'Inaheart Member' },
          component: () => import('./views/about/InaheartMember'),
        },
        {
          path: '/about/contact-us',
          name: 'Contact Us',
          meta: { title: 'Contact Us' },
          component: () => import('./views/about/ContactUs'),
        },
        {
          path: '/guidelines/statements',
          name: 'Guidelines & Statements',
          meta: { title: 'Guidelines & Statements' },
          component: () => import('./views/guidelines/GuidelinesStatements'),
        },
        {
          path: '/guidelines/journal',
          name: 'Indonesian Journal of Cardiology',
          meta: { title: 'Indonesian Journal of Cardiology' },
          component: () => import('./views/guidelines/IndonesianJournal'),
        },
        {
          path: '/guidelines/news',
          name: 'News & Articles',
          meta: { title: 'News & Articles' },
          component: () => import('./views/guidelines/NewsArticles'),
        },
        {
          path: '/guidelines/events',
          name: 'Events',
          meta: { title: 'Events' },
          component: () => import('./views/guidelines/Events'),
        },
        {
          path: '/content/:id',
          name: 'ContentDetail',
          meta: { title: 'Content Detail' },
          component: () => import('./views/guidelines/ContentDetail.vue'),
        },
        {
          path: '/courses/acls',
          name: 'ACLS Training',
          meta: { title: 'ACLS Training' },
          component: () => import('./views/courses/ACLSTraining'),
        },
        {
          path: '/courses/programs',
          name: 'Courses & Programs (Coming Soon)',
          meta: { title: 'Courses & Programs (Coming Soon)' },
          component: () => import('./views/courses/CoursesPrograms'),
        },
        {
          path: '/admin/users',
          name: 'User Management',
          meta: {
            title: 'User Management',
            requiresAdmin: true,
          },
          component: () => import('./views/admin/UserManagement'),
        },
        {
          path: '/admin/groups',
          name: 'Group Management',
          meta: {
            title: 'Group Management',
            requiresSuperAdmin: true,
          },
          component: () => import('./views/admin/GroupManagement'),
        },
        {
          path: '/notifications',
          name: 'Notifications',
          meta: {
            title: 'Notifications',
          },
          component: () => import('./views/notifications/NotificationList'),
        },
        {
          path: '/algoritma-klinis',
          name: 'AlgoritmaKlinisList',
          meta: {
            title: 'Algoritma Klinis',
          },
          component: () => import('./views/algoritma-klinis/List'),
        },
        {
          path: '/algoritma-klinis/:id',
          name: 'AlgoritmaKlinisDetail',
          meta: {
            title: 'Detail Algoritma Klinis',
          },
          component: () => import('./views/algoritma-klinis/Detail'),
        },
      ],
    },

    // System Pages
    {
      path: '/',
      component: AuthLayout,
      meta: { authRequired: false, isAuth: false },
      name: 'auth',
      children: [
        {
          path: '/masuk',
          name: 'masuk',
          meta: {
            title: 'Masuk',
          },
          component: () => import('@/views/auth/Login.vue'),
        },
        {
          path: '/mobile-cms/login',
          name: 'MobileCmsLogin',
          meta: { title: 'Mobile CMS Login', isMobileCms: true, authRequired: false },
          component: () => import('./views/mobile-cms/Login.vue'),
        },
        {
          path: 'register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/Register.vue'),
        },
        {
          path: '/forgot-password',
          name: 'Forgot Password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/reset-password',
          name: 'Lupa Password',
          meta: {
            title: 'Lupa Password',
          },
          component: () => import('./views/auth/reset-password'),
        },
        {
          path: '/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },
    {
      path: '/404',
      name: 'route404',
      meta: {
        title: 'Error 404',
      },
      component: () => import('./views/auth/404'),
    },
    // {
    //   path: '/email-approval',
    //   name: 'Email Approval',
    //   meta: {
    //     title: 'Email Approval',
    //     authRequired: false,
    //   },
    //   component: () => import('./views/approval/email.vue'),
    // },
    {
      path: '/500',
      meta: {
        title: 'Error 500',
      },
      component: () => import('./views/auth/500'),
    },

    // Mobile CMS Routes (with layout)
    {
      path: '/mobile-cms',
      component: DashLayout,
      meta: { isMobileCms: true },
      children: [
        {
          path: '',
          redirect: () => {
            const role = localStorage.getItem('mobile_cms_role')
            return role === 'super_admin'
              ? '/mobile-cms/admin-management'
              : 'member-application/dashboard'
          },
        },
        {
          path: 'dashboard',
          name: 'MobileCmsDashboard',
          meta: { title: 'Mobile CMS Dashboard', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/Dashboard.vue'),
        },
        {
          path: 'admin-management',
          name: 'MobileCmsAdminManagement',
          meta: { title: 'Admin Management', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/AdminManagement.vue'),
        },
        {
          path: 'user-management',
          name: 'MobileCmsUserManagement',
          meta: { title: 'User Management', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/UserManagement.vue'),
        },
        {
          path: 'banner',
          name: 'MobileCmsBanner',
          meta: { title: 'Banner', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/Banner.vue'),
        },
        {
          path: 'guidelines',
          name: 'MobileCmsGuidelines',
          meta: { title: 'Guidelines', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/guideline/Sources.vue'),
        },
        {
          path: 'guidelines/:sourceId',
          name: 'MobileCmsGuidelineDocuments',
          meta: { title: 'Guideline Documents', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/guideline/Documents.vue'),
        },
        {
          path: 'guidelines/structure/:id',
          name: 'MobileCmsGuidelineStructure',
          meta: { title: 'Guideline Structure', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/guideline/Structure.vue'),
        },
        {
          path: 'guidelines/diagnosis/:id',
          name: 'MobileCmsDiagnosisDetail',
          meta: { title: 'Diagnosis Detail', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/guideline/DiagnosisDetail.vue'),
        },
        {
          path: 'algoritma-klinis',
          name: 'MobileCmsAlgoritmaKlinis',
          meta: { title: 'Alur Algoritma Klinis', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/AlurAlgoritmaKlinis.vue'),
        },
        {
          path: 'algoritma-klinis/create',
          name: 'MobileCmsAlgoritmaKlinisCreate',
          meta: { title: 'Tambah Alur Algoritma Klinis', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/AlurAlgoritmaKlinisForm.vue'),
        },
        {
          path: 'algoritma-klinis/edit/:id',
          name: 'MobileCmsAlgoritmaKlinisEdit',
          meta: { title: 'Edit Alur Algoritma Klinis', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/AlurAlgoritmaKlinisForm.vue'),
        },
        {
          path: 'member-application',
          name: 'MobileCmsMemberApplication',
          meta: { title: 'Pendaftaran Member', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/MemberApplication.vue'),
        },
        {
          path: 'member-application/:id',
          name: 'MobileCmsMemberApplicationDetail',
          meta: { title: 'Detail Pendaftaran Member', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/MemberApplicationDetail.vue'),
        },
        {
          path: 'member-perki',
          name: 'MobileCmsMemberPerki',
          meta: { title: 'Member PERKI', isMobileCms: true, authRequired: true },
          component: () => import('./views/admin/MemberPerki'),
        },
        {
          path: 'member-application/dashboard',
          name: 'MobileCmsMemberApplicationDashboard',
          meta: { title: 'Dashboard Membership', isMobileCms: true, authRequired: true },
          component: () => import('./views/mobile-cms/MemberApplicationDashboard.vue'),
          },
          {
            path: 'notifications',
            name: 'MobileCmsNotifications',
            meta: { title: 'Notifikasi', isMobileCms: true, authRequired: true },
            component: () => import('./views/notifications/NotificationList.vue'),
        },
        // {
        //   path: 'algoritma-klinis/:id',
        //   name: 'MobileCmsAlgoritmaKlinisDetail',
        //   meta: { title: 'Detail Alur Algoritma Klinis', isMobileCms: true, authRequired: true },
        //   component: () => import('./views/mobile-cms/AlurAlgoritmaKlinisDetail.vue'),
        // },
      ],
    },

    // Redirect to 404
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'route404' },
    },
  ],
})
router.beforeEach(async (to, from, next) => {
  // Handle Mobile CMS routes separately
  if (to.meta.isMobileCms) {
    const mobileCmsToken = localStorage.getItem('mobile_cms_token')

    // Already authenticated, don't show login page again
    if (to.name === 'MobileCmsLogin' && mobileCmsToken) {
      const role = localStorage.getItem('mobile_cms_role')
      next(role === 'super_admin' ? '/mobile-cms/admin-management' : '/mobile-cms/member-application/dashboard')
      return
    }

    // Require auth: redirect to CMS login
    if (to.meta.authRequired && !mobileCmsToken) {
      next({ path: '/mobile-cms/login', query: { redirect: to.fullPath } })
      return
    }

    next()
    return
  }

  const requiresAuth = to.meta.authRequired
  const requiresAdmin = to.meta.requiresAdmin
  const requiresSuperAdmin = to.meta.requiresSuperAdmin
  const token = localStorage.getItem('perki_token')
  const userRole = localStorage.getItem('perki_role')

  // Helper: redirect to login with redirect param
  const goToLoginWithRedirect = () => {
    next({
      path: '/masuk',
      query: {
        redirect: to.fullPath,
      },
    })
  }

  // Jika route butuh auth / admin / super admin, pastikan token valid dulu
  if (requiresAuth || requiresAdmin || requiresSuperAdmin) {
    if (!token) {
      // Tidak ada token, langsung ke login
      return goToLoginWithRedirect()
    }

    // Ada token, cek ke backend apakah masih valid
    try {
      await store.dispatch('user/LOAD_CURRENT_ACCOUNT', { token })
    } catch (err) {
      // Jika gagal (misal 401 / token invalid / expired), hapus token dan paksa login ulang
      localStorage.removeItem('perki_token')
      localStorage.removeItem('perki_user')
      localStorage.removeItem('perki_role')
      return goToLoginWithRedirect()
    }
  }

  // Check super admin access
  if (requiresSuperAdmin) {
    if (!token) {
      return goToLoginWithRedirect()
    }
    if (userRole !== 'super_admin') {
      next('/')
      return
    }
  }

  // Check admin access
  if (requiresAdmin) {
    if (!token) {
      return goToLoginWithRedirect()
    }
    if (userRole !== 'super_admin' && userRole !== 'admin') {
      next('/')
      return
    }
  }

  next()
})

export default router
